<ami-dialog-message [setting]="message"></ami-dialog-message>
<div class="card">
    <div class="flex justify-content-between align-items-center mb-4 border-bottom-1 surface-border pb-3">
        <div>
            <h5 class="m-0">Nueva Exportación</h5>
            <span class="text-500 text-sm">Complete la configuración para generar el reporte PLE</span>
        </div>
        <i class="pi pi-times text-500 hover:text-900 cursor-pointer text-xl transition-colors bg-transparent border-none"
            (click)="cancelWizard()" pTooltip="Cancelar" tooltipPosition="bottom"></i>
    </div>

    <!-- COMPONENTS -->
    <app-step-configuration [(selectedMonth)]="selectedMonth" [(selectedYear)]="selectedYear" [(formatTxt)]="formatTxt"
        [(formatXls)]="formatXls" [isLoading]="isLoading" (next)="generateExport()">
    </app-step-configuration>
</div>